import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Wallet_Sales_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

function Wallet_Sales_Report() {
  const [salesData, setSalesData] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [loading, setLoading] = useState(false);

  // Set default startDate to 2021 as per your latest snippet
  const [filters, setFilters] = useState({
    studentId: "",
    startDate: "2021-01-27",
    endDate: "2026-02-02",
  });

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        request_start_date: filters.startDate,
        request_end_date: filters.endDate,
        student_id: filters.studentId || "",
      };

      const response = await simplePostCall(
        ApiConfig.salesreporteports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setSalesData(response.data || []);

        // Populate the student list dropdown if available and not yet set
        if (response.student_list && studentList.length === 0) {
          setStudentList(response.student_list);
        }
      }
    } catch (error) {
      console.error("Error fetching wallet sales report:", error);
    } finally {
      setLoading(false);
    }
  }, [filters, studentList.length]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [id === "student_id"
        ? "studentId"
        : id === "startdate"
          ? "startDate"
          : "endDate"]: value,
    }));
  };

  const handleClear = () => {
    setFilters({
      studentId: "",
      startDate: "2021-01-27",
      endDate: "2026-02-02",
    });
  };

  return (
    <div className="wallet-report-container" style={{ paddingTop: "25px" }}>
      <div className="wallet-header-section">
        <div className="wallet-header-box">
          <h3 className="wallet-header-title">Wallet Sales Report</h3>
          <div className="wallet-export-section">
            <button className="wallet-export-button">
              Export <i className="fa fa-angle-down"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Filter Section */}
      <div className="wallet-filter-section">
        <div className="wallet-filter-row">
          <div className="wallet-filter-item">
            <select
              id="student_id"
              className="wallet-select"
              value={filters.studentId}
              onChange={handleFilterChange}
            >
              <option value="">Select Student</option>
              {studentList.map((std) => (
                <option key={std.student_id} value={std.student_id}>
                  {std.student_name}
                </option>
              ))}
            </select>
          </div>

          <div className="wallet-filter-item">
            <input
              type="date"
              id="startdate"
              className="wallet-date-input"
              value={filters.startDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="wallet-filter-item">
            <input
              type="date"
              id="enddate"
              className="wallet-date-input"
              value={filters.endDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="wallet-filter-item">
            <button
              className="wallet-btn wallet-btn-search"
              onClick={fetchInitialData}
              disabled={loading}
            >
              {loading ? "Searching..." : "Search"}
            </button>
            <button
              className="wallet-btn wallet-btn-clear"
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div
        className="wallet-table-container"
        style={{ marginRight: "15px", marginLeft: "15px" }}
      >
        <table className="payment-mode-table">
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Date</th>
              <th>Student Name</th>
              <th>Admission No</th>
              <th>Reference No</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {salesData.length > 0 ? (
              salesData.map((item, index) => (
                <tr key={item.sale_id || index}>
                  <td>{index + 1}</td>
                  <td>{item.formatted_date}</td>
                  <td>{item.student_name}</td>
                  <td>{item.student_admission_num}</td>
                  <td>{item.sale_reference_no || "—"}</td>
                  <td style={{ fontWeight: "bold", color: "#2dce89" }}>
                    {item.sale_amount}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: "center", padding: "7px" }}>
                  <div className="text-center">
                    <ScaleLoader color="#F4BB44" />
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Wallet_Sales_Report;
